import { Component, type ReactNode } from 'react';
import { IconAlertCircle, IconRefresh } from '@tabler/icons-react';
import { Button } from '@/components/ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
} from '@/components/ui/empty';
import { StateTitle } from '@/components/ui/page-title';
import * as m from '@/paraglide/messages.js';

export class AppErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="p-8">
        <Empty className="mx-auto my-10 max-w-lg">
          <EmptyHeader role="alert">
            <EmptyMedia variant="icon">
              <IconAlertCircle aria-hidden="true" />
            </EmptyMedia>
            <StateTitle>{m.page_error_title()}</StateTitle>
            <EmptyDescription>{m.app_error_description()}</EmptyDescription>
          </EmptyHeader>
          <EmptyContent>
            <Button autoFocus onClick={() => window.location.reload()}>
              <IconRefresh aria-hidden="true" data-icon="inline-start" />
              {m.page_error_reload()}
            </Button>
          </EmptyContent>
        </Empty>
      </main>
    );
  }
}
